import { PATH_NAME_NOT_SUPPORT_MOBILE_WEB } from '@/common/router.const'

export default [
  // 다른 플랫폼에서 지원하지만 모바일 웹에서 지원하지 않는 페이지의 안내 페이지
  {
    /*
    https://www.wavve.com/player/baseball/live?game_id={game_id}
    https://www.wavve.com/baseball/result?game_id={game_id}
    https://www.wavve.com/player/baseball/highlight?contentid={contentid}
    https://www.wavve.com/baseball
    https://www.wavve.com/basball/schedule
    https://www.wavve.com/basball/highlight/{uicode}?api=apis.wavve.com%252Fdp%252Fvod%252Fscene%253Fcliptype%253DFHL%2526orderby%253Dnew%2526contenttype%253Dclip%2526WeekDay%253Dall%2526uitype%253DVN401%2526uiparent%253DGN9-VN401%2526uirank%253D4%2526broadcastid%253D13896%2526offset%253D0%2526limit%253D20&came=baseball&date={date}
    */
    path: '/baseball',
    name: PATH_NAME_NOT_SUPPORT_MOBILE_WEB,
    alias: ['/baseball/*', '/player/baseball/*'],
    components: {
      notfound: () => import('@/views/error/NotSupportMobileWeb')
    }
  }
]
